module.exports = __webpack_public_path__ + "img/cmmi中文.112d550f.png";